import styled from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isActive: boolean
}

export const Button = styled(Link)<Props>`
	padding: 12px 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	column-gap: 4px;
	width: 100%;
	font-size: 14px;
	font-weight: 500;
	color: ${helpers.color.text};
	font-family: ${helpers.font.family.header};

	&:hover {
		text-decoration: none;
		color: ${helpers.color.text};
		background-color: ${helpers.color.linkBackgroundHover};
	}

	&:active,
	&:focus {
		color: ${helpers.color.text};
		text-decoration: none;
	}
`
